import { Route, Routes } from 'react-router-dom'
import { useCurrentUser } from '~/common'
import { AuthWrapped } from '~/modules/navigation/components'
import { ReturnHubPage, ReturnHubDetailsPage, ReturnHubFormPage } from '~/modules/returnhubsccc/view'

import { DeleteConfirmationDialog } from '~/modules/returnhubsccc/components'
const PATH = {
  OVERVIEW: '/',
  ADD: 'add',
  EDIT: 'edit',
  DELETE: 'delete',
  DETAILS: 'details',
}

export const ReturnHubRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('CCC_RETURN_HUBS')
  return (
    <Routes>
      <Route index element={<AuthWrapped component={ReturnHubPage} canAccess={canAccess} />} />
      <Route
        path={`${PATH.DETAILS}/:id`}
        element={<AuthWrapped component={ReturnHubDetailsPage} canAccess={canAccess} />}
      />
      <Route path={PATH.ADD} element={<AuthWrapped component={ReturnHubFormPage} canAccess={canAccess} />} />
      <Route path={`${PATH.EDIT}/:id`} element={<AuthWrapped component={ReturnHubFormPage} canAccess={canAccess} />} />
      <Route
        path={`${PATH.DELETE}/:id`}
        element={<AuthWrapped component={DeleteConfirmationDialog} canAccess={canAccess} />}
      />
    </Routes>
  )
}

export const returnHubsLinks = {
  returnHubsLink: () => PATH.OVERVIEW,
  addReturnHubLink: () => `/${PATH.ADD}`,
  returnHubsDetailLink: (id: string) => `/${PATH.DETAILS}/${id}`,
  editReturnHubLink: (id: string) => `/${PATH.EDIT}/${id}`,
  deleteReturnHubLink: (id: string) => `/${PATH.DELETE}/${id}`,
}
